<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import { Button } from '../../components/ui'

  let { areas = [] } = $props()

  const toggleSocial = (item, social_enabled) => {
    router.patch(`/college-towns/${item.id}`, { area: { social_enabled } }, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="College Towns" subtitle="Areas that scope colleges, places, and feeds" count={areas.length}>
    {#snippet actions()}
      <Button href="/college-towns/new" variant="primary" size="sm" icon="add">New College Town</Button>
    {/snippet}
  </PageHeader>

  <EntityList entity="college_town" rows={areas} onToggle={toggleSocial} />
</Layout>
